<template>
  <ipo3-page>
    <template slot="title">比較清單</template>
    <template slot="tools">
      <el-input v-model="form.title" style="width:200px;margin-right:10px;" placeholder="請輸入標題"></el-input>
      <el-button icon="el-icon-edit" @click="onSearch" type="primary">搜索</el-button>
      <el-button icon="el-icon-edit" @click="onCreate" type="primary">添加比較</el-button>
    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button
                  @click="onHandle(scope.$index, scope.row)"
                  size="mini"
                  type="success"
                >編輯</el-button>
                 <el-button
                  @click="onDelete(scope.$index, scope.row)"
                  size="mini"
                  type="danger"
                >{{$t('btns.del')}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
      <compare-dialog ref="compareDialog" @sucess="onSucess"></compare-dialog>
    </template>
  </ipo3-page>
</template>
<script>
import compareDialog from "./views/compare_dialog";
export default {
  name: "news-compare",
  components: { compareDialog },
  data() {
    return {
      tableData: [],
      isLoading: false,
      getRowClass: {
        background: "#F2F2F2"
      },
      form:{
        title:''
      },
      items: [
         { name: "編號", id: "id" },
        { name: "名稱", id: "name" },
        { name: "狀態", id: "status" },
        { name: "時間", id: "create_time" }
      ],
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },
  created() {
    this.getData();
  },
  methods: {
     onSearch()
    {
      let params = Object.assign({},this.form);
      
      this.getData(this.currentPage,this.paginate,params);
    },
    onCreate(){
      this.$refs.compareDialog.show();
    },
    onHandle(index,value)
    {
      this.$refs.compareDialog.show(value);
    },
    onDelete(index,value)
    {
      var self = this;
      this.$http.post('/admin/compare/delete',{id:value.id}).then(res=>{
          if(res.code==200)
          {
            self.getData();
            self.$message.success("删除成功");
          }else
          {
            self.$message.error(res.msg);
          }
      });
    },
    onSucess(){
      this.getData();
    },
    getData(page = 1, size = 10,value={}) {
      var self = this;
      this.$http.get("/admin/compare", { page: page, size: size ,...value}).then(res => {
        console.log("res:", res);
        let { total,data } = res.data;
        self.pagecount = total;
        self.tableData = data;
      });
    },
    handleCurrentChange(value) {
      this.currentPage = value;
      this.getData(this.currentPage, this.paginate);
    },
    handleSizeChange(size) {
      this.paginate = size;
      this.getData(this.currentPage, this.paginate);
    }
  }
};
</script>